import axios from '../../../axios';
import { ICustomField } from '../types/Field';

const baseUrl = 'invoicingservice/api/custom-field';

export const getAllCustomFields = () => axios.get(baseUrl);

export const getAllCustomFieldsByEntity = (entity: string) =>
  axios.get(`${baseUrl}/entity/${entity}`);

export const createCustomField = (field: ICustomField) => axios.post(baseUrl, field);

export const updateCustomField = (field: ICustomField) => axios.put(baseUrl, field);
